import { Country } from '@/helpers/conf';
import { Locale } from '@/helpers/languages';

type Languages = {
  [codeCountry: string]: {
    locale: Locale;
    countryIcon: string;
    subName?: string;
  }[];
};

export const LANGUAGES: Languages = {
  [Country.UnitedKingdom]: [
    {
      locale: Locale.ENGLISH,
      countryIcon: 'en',
      subName: 'en',
    },
  ],
  [Country.Germany]: [
    {
      locale: Locale.GERMAN,
      countryIcon: 'de',
    },
  ],
  [Country.Canada]: [
    {
      locale: Locale.ENGLISH_CANADA,
      countryIcon: 'en-CA',
    },
    {
      locale: Locale.FRENCH_CANADA,
      countryIcon: 'fr-CA',
      subName: 'fr-CA',
    },
  ],
  [Country.Switzerland]: [
    {
      locale: Locale.GERMAN,
      countryIcon: 'de',
    },
    {
      locale: Locale.FRENCH_SWITZERLAND,
      countryIcon: 'fr-CH',
      subName: 'fr-CH',
    },
  ],
  [Country.Norway]: [
    {
      locale: Locale.NORWEGIAN,
      countryIcon: 'no',
      subName: 'no',
    },
  ],
  [Country.Australia]: [
    {
      locale: Locale.ENGLISH_AUSTRALIA,
      countryIcon: 'en-AU',
    },
  ],
  [Country.Ireland]: [
    {
      locale: Locale.ENGLISH_IRELAND,
      countryIcon: 'en-IE',
    },
  ],
  [Country.NewZealand]: [
    {
      locale: Locale.ENGLISH_NEW_ZEALAND,
      countryIcon: 'en-NZ',
    },
  ],
  [Country.Estonia]: [
    {
      locale: Locale.ESTONIA,
      countryIcon: 'et',
    },
  ],
  [Country.Finland]: [
    {
      locale: Locale.FINLAND,
      countryIcon: 'fi',
    },
  ],
  [Country.France]: [
    {
      locale: Locale.ENGLISH,
      countryIcon: 'en',
    },
  ],
  [Country.Spain]: [
    {
      locale: Locale.ENGLISH,
      countryIcon: 'en',
    },
  ],
  [Country.Portugal]: [
    {
      locale: Locale.ENGLISH,
      countryIcon: 'en',
    },
  ],
};

export const AVAILABLE_LOCALES = Object.values(Locale);

export const NAMESPACES = [
  'common',
  'validation',
  'lobby',
  'leaveRegistration',
];

export const DEFAULT_NS = NAMESPACES[0];

export const DEFAULT_LOCALE = Locale.ENGLISH;
